/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_HInputs */



/**
* | output |
* | --- |
* | "H" |
*
* @param {Editor_Table_Column_HInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_h = /** @type {((inputs?: Editor_Table_Column_HInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_HInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("H")
	if (locale === "de") return /** @type {LocalizedString} */ ("H")
	if (locale === "it") return /** @type {LocalizedString} */ ("H")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЧАС")
	if (locale === "es") return /** @type {LocalizedString} */ ("H")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("H")
	if (locale === "ja") return /** @type {LocalizedString} */ ("H")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("H")
	return /** @type {LocalizedString} */ ("H")
});